import { Component, forwardRef, HostBinding, OnInit } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Compliment } from '@fmnts/api';
import { logger } from '@fmnts/common/log';
import { FmntsComplimentModule } from '@fmnts/components/compliment';
import {
  AbstractDeclarativeInputFieldComponent,
  FormSelectField,
} from '@fmnts/declarative-forms';
import { I18nModule } from '@fmnts/i18n';

type FieldValue = readonly string[];

/**
 * Form field component that shows an input for selecting
 * compliments.
 */
@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'next-compliments-select-field',
  templateUrl: './compliments-select-field.component.html',
  imports: [FmntsComplimentModule, I18nModule, FormsModule],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ComplimentsSelectFieldComponent),
      multi: true,
    },
  ],
})
export class ComplimentsSelectFieldComponent
  extends AbstractDeclarativeInputFieldComponent<FormSelectField, FieldValue>
  implements OnInit
{
  @HostBinding('class') componentClass = 'form-field form-field__compliments';
  #log = logger({ name: 'ComplimentsSelectFieldComponent' });

  public compliments: Compliment[] = [];

  get value(): FieldValue {
    return this._value;
  }
  set value(newValue: FieldValue) {
    this._value = newValue;
    this._onChange(this._value);
    this._onTouched();
  }
  private _value: FieldValue = [];

  ngOnInit(): void {
    this.compliments = this.field.widgetOptions.items.map(
      (c) => new Compliment(c as Compliment),
    );
  }

  override writeValue(obj: unknown): void {
    // Ensure that selected is an array
    this._value = (obj as FieldValue) ?? [];
  }

  protected override setFocusedState(isFocused: boolean): void {
    this.#log.error('setFocusedState: Method not implemented.');
  }
}
